/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ScheduledFrequencyEnum,
    ScheduledFrequencyEnumFromJSON,
    ScheduledFrequencyEnumFromJSONTyped,
    ScheduledFrequencyEnumToJSON,
} from './ScheduledFrequencyEnum';

/**
 * 
 * @export
 * @interface PersonalAssetScheduledDto
 */
export interface PersonalAssetScheduledDto {
    /**
     * 
     * @type {ScheduledFrequencyEnum}
     * @memberof PersonalAssetScheduledDto
     */
    frequency: ScheduledFrequencyEnum | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetScheduledDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetScheduledDto
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetScheduledDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetScheduledDto
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersonalAssetScheduledDto
     */
    lastProcessed?: Date;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetScheduledDto
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalAssetScheduledDto
     */
    personalAssetId: string;
}

export function PersonalAssetScheduledDtoFromJSON(json: any): PersonalAssetScheduledDto {
    return PersonalAssetScheduledDtoFromJSONTyped(json, false);
}

export function PersonalAssetScheduledDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetScheduledDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'frequency': ScheduledFrequencyEnumFromJSON(json['frequency']),
        'id': json['id'],
        'name': json['name'],
        'startDate': (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'lastProcessed': !exists(json, 'lastProcessed') ? undefined : (new Date(json['lastProcessed'])),
        'value': json['value'],
        'personalAssetId': json['personalAssetId'],
    };
}

export function PersonalAssetScheduledDtoToJSON(value?: PersonalAssetScheduledDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'frequency': ScheduledFrequencyEnumToJSON(value.frequency),
        'id': value.id,
        'name': value.name,
        'startDate': (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'lastProcessed': value.lastProcessed === undefined ? undefined : (value.lastProcessed.toISOString()),
        'value': value.value,
        'personalAssetId': value.personalAssetId,
    };
}

